import { IKnmRemark } from '../../../APIPackage/CatalogsModule/interfaces/IKnmRemark';

export const createKnmRemarkSelectOption = (knmRemark: IKnmRemark) => ({
  ...knmRemark,
  label: knmRemark.name,
  value: knmRemark.id,
});
